import React, { useState } from "react";
import Event from "./GetEventMarsComplete.jsx/EventMarsComplete"
import useFormContext from "./GetEventMarsComplete.jsx/useFormMarsComplete"
import Schedule from "./GetEventMarsComplete.jsx/ScheduleMarsComplete"
import ScheduleRequestor from "./ResponsiveEvent.jsx/ScheduleRequestor"
import Guests from "./GetEventMarsComplete.jsx/GuestsMarsComplete"
import Summary from "./GetEventMarsComplete.jsx/SummaryMarsComplete"
import SummaryRequestor from "./ResponsiveEvent.jsx/SummaryRequestor"
import History from "./ResponsiveEvent.jsx/History"

const FormInputs = ( {userIsEventRequestor} ) => {

    const { page } = useFormContext()
    var subScreens = [];    
    if (userIsEventRequestor) 
        subScreens = {
            0: <Event />,
            1: <ScheduleRequestor familyMode="true" />,
            2: <Guests />,
            3: <History familyMode="true" />,
            4: <SummaryRequestor familyMode="true" />
        };
    else
        subScreens = {
            0: <Event />,
            1: <Schedule />,
            2: <Guests />,
            3: <Summary />
        };

    const content = (
        <>
            {subScreens[page]}
        </>
    )


    return content
}
export default FormInputs